import { z } from "zod/v4";

import { StandardEventAllowedKeyMetricsList } from "./analytics-events/standard-events";

export const ExperienceKeyMetricDtoSchema = z.object({
  id: z.uuid().describe("Unique identifier for the key metric"),
  experienceId: z.uuid().describe("Experience this metric belongs to"),
  order: z.number().describe("Display order in analytics dashboard"),
  isPrimary: z
    .boolean()
    .default(false)
    .describe("Whether this is the primary success metric for the experience"),
  standardEventId: z
    .enum(StandardEventAllowedKeyMetricsList)
    .nullish()
    .describe(
      "Standard e-commerce event to track: 'revenue', 'conversion', 'aov', etc."
    ),
  experienceCustomMetricId: z
    .uuid()
    .nullish()
    .describe("ID of custom metric if using custom event instead of standard"),
});
export type ExperienceKeyMetricDto = z.infer<
  typeof ExperienceKeyMetricDtoSchema
>;

export const CreateExperienceKeyMetricDtoSchema =
  ExperienceKeyMetricDtoSchema.extend({
    id: z
      .uuid()
      .optional()
      .describe("Unique identifier (auto-generated if not provided)"),
    experienceId: z
      .uuid()
      .optional()
      .describe("Experience ID (optional when creating with experience)"),
  });

export type CreateExperienceKeyMetricDto = z.infer<
  typeof CreateExperienceKeyMetricDtoSchema
>;
